import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=afee250c&"
import script from "./ConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afee250c')) {
      api.createRecord('afee250c', component.options)
    } else {
      api.reload('afee250c', component.options)
    }
    module.hot.accept("./ConfirmDialog.vue?vue&type=template&id=afee250c&", function () {
      api.rerender('afee250c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/ConfirmDialog.vue"
export default component.exports